import { render, staticRenderFns } from "./wiki_sticky_header.vue?vue&type=template&id=fd1aa710&scoped=true&vue3"
import script from "./wiki_sticky_header.vue?vue&type=script&lang=js&vue3"
export * from "./wiki_sticky_header.vue?vue&type=script&lang=js&vue3"
import style0 from "./wiki_sticky_header.vue?vue&type=style&index=0&id=fd1aa710&prod&scoped=true&lang=css&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1aa710",
  null
  
)

export default component.exports